module.exports = __webpack_public_path__ + "img/ad2.67307b7a.png";